import _get from 'lodash/get'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { P, match } from 'ts-pattern'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { ListedItems as ListedItemsProps } from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'
import { IMAGE } from '@ui-kit/assets/images/index.native'
import UiKitListItem from '@ui-kit/components/listComponents/ListItem'

import { styles } from './styles'

export const ListedItems = (props: ListedItemsProps & { flowValues: FlowValues }) => {
  const { t } = useTranslation()
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, {
    flowValues: props.flowValues,
    servicesResponses,
  })
  const { container } = styles()
  const translatedItems = props.items.map((item) => {
    const image = match(item.image)
      .with(P.not(P.nullish), (parsedImage) => _get(IMAGE.icons.small, parsedImage) ?? parsedImage)
      .otherwise(() => undefined)

    return {
      id: item.id,
      title: translateFunction(item.title),
      subtitle: item.subtitle ? translateFunction(item.subtitle) : undefined,
      tagLabel: item.tagLabel ? translateFunction(item.tagLabel) : undefined,
      icon: item.icon ? _get(IMAGE.icons.small, item.icon) : undefined,
      bordered: Boolean(item.bordered),
      imageSize: item.imageSize,
      paddingY: item.paddingY,
      underlinedTitle: Boolean(item.underlinedTitle),
      lineThrough: Boolean(item.lineThrough),
      color: item.color,
      image,
    }
  })

  return (
    <View className={container()}>
      {translatedItems.map((item) => (
        <UiKitListItem {...item} key={item.id} />
      ))}
    </View>
  )
}
